var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpArrow = function SvgUpArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.247,
    height: 12.82
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8763"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8761"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#b9b9b9",
    d: "M22.901 12.469a1.2 1.2 0 0 0 0-1.692L12.469.346a1.2 1.2 0 0 0-1.692 0L.351 10.778a1.2 1.2 0 0 0 1.692 1.692l9.581-9.581 9.577 9.58a1.2 1.2 0 0 0 1.7 0",
    "data-name": "Path 14175"
  })))));
};
export default SvgUpArrow;